import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var GtmAnalytics = /*#__PURE__*/function () {
  // eslint-disable-next-line no-console
  function GtmAnalytics() {
    var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console.log;

    _classCallCheck(this, GtmAnalytics);

    this.logger = logger;
  }

  _createClass(GtmAnalytics, [{
    key: "sendEvent",
    value: function sendEvent(category, action, label) {
      var layers = ["dataLayer"];

      if (typeof window === "undefined") {
        return;
      } // Iterate over all potential dataLayer variables and check if they exist


      for (var _i = 0, _layers = layers; _i < _layers.length; _i++) {
        var layer = _layers[_i];

        if (typeof window[layer] !== "undefined") {
          // Send the event into GTM
          window[layer].push({
            event: "analyticsEvent",
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: null,
            eventNonInt: false
          });
        }
      }
    }
  }]);

  return GtmAnalytics;
}();

export default GtmAnalytics;